export interface QuizQuestion {
  id: number
  step: number
  question: string
  type: 'options'
  options: Array<{
    emoji: string
    text: string
  }>
}

export const questions: QuizQuestion[] = [
  {
    id: 1,
    step: 5,
    question: "Como você se conecta melhor com sua espiritualidade?",
    type: "options",
    options: [
      { emoji: "🧘", text: "Através da meditação" },
      { emoji: "📚", text: "Estudando e aprendendo" },
      { emoji: "🙏", text: "Pela fé e oração" },
      { emoji: "🌿", text: "Conectando com a natureza" }
    ]
  },
  {
    id: 2,
    step: 6,
    question: "Qual área da sua vida precisa mais de atenção agora?",
    type: "options",
    options: [
      { emoji: "💖", text: "Relacionamentos" },
      { emoji: "💰", text: "Finanças" },
      { emoji: "🎯", text: "Carreira" },
      { emoji: "🧠", text: "Desenvolvimento pessoal" }
    ]
  },
  {
    id: 3,
    step: 7,
    question: "Como você lida com desafios?",
    type: "options",
    options: [
      { emoji: "🤔", text: "Analiso cuidadosamente" },
      { emoji: "💪", text: "Enfrento de frente" },
      { emoji: "🤝", text: "Busco ajuda" },
      { emoji: "🎭", text: "Adapto-me criativamente" }
    ]
  },
  {
    id: 4,
    step: 8,
    question: "Qual é sua maior força interior?",
    type: "options",
    options: [
      { emoji: "🦁", text: "Coragem" },
      { emoji: "🎨", text: "Criatividade" },
      { emoji: "❤️", text: "Compaixão" },
      { emoji: "🌟", text: "Determinação" }
    ]
  },
  {
    id: 5,
    step: 9,
    question: "O que mais te motiva?",
    type: "options",
    options: [
      { emoji: "🎯", text: "Alcançar objetivos" },
      { emoji: "🤝", text: "Ajudar outros" },
      { emoji: "✨", text: "Crescimento pessoal" },
      { emoji: "💡", text: "Aprender coisas novas" }
    ]
  },
  {
    id: 6,
    step: 10,
    question: "Como você se vê daqui a 5 anos?",
    type: "options",
    options: [
      { emoji: "📈", text: "Mais próspero" },
      { emoji: "🧘", text: "Mais equilibrado" },
      { emoji: "👥", text: "Ajudando mais pessoas" },
      { emoji: "🌍", text: "Fazendo a diferença" }
    ]
  },
  {
    id: 7,
    step: 11,
    question: "O que te faz sentir mais realizado?",
    type: "options",
    options: [
      { emoji: "🎯", text: "Atingir metas" },
      { emoji: "💝", text: "Fazer outros felizes" },
      { emoji: "📚", text: "Adquirir conhecimento" },
      { emoji: "🌱", text: "Evoluir como pessoa" }
    ]
  },
  {
    id: 8,
    step: 12,
    question: "Como você prefere trabalhar?",
    type: "options",
    options: [
      { emoji: "👤", text: "Independentemente" },
      { emoji: "👥", text: "Em equipe" },
      { emoji: "🎨", text: "Criativamente" },
      { emoji: "📊", text: "Estruturadamente" }
    ]
  },
  {
    id: 9,
    step: 13,
    question: "Qual sua maior aspiração?",
    type: "options",
    options: [
      { emoji: "⭐", text: "Reconhecimento" },
      { emoji: "💖", text: "Fazer diferença" },
      { emoji: "💰", text: "Prosperidade" },
      { emoji: "🔮", text: "Sabedoria" }
    ]
  },
  {
    id: 10,
    step: 14,
    question: "Você sente que está vivendo todo seu potencial?",
    type: "options",
    options: [
      { emoji: "🤔", text: "Ainda há muito a desenvolver" },
      { emoji: "✨", text: "Estou no caminho certo" },
      { emoji: "💭", text: "Preciso de mais clareza" },
      { emoji: "🎯", text: "Quero ir mais longe" }
    ]
  },
  {
    id: 11,
    step: 15,
    question: "Gostaria de descobrir seu propósito de vida completo?",
    type: "options",
    options: [
      { emoji: "✨", text: "Sim, quero me conhecer melhor" },
      { emoji: "🎯", text: "Sim, preciso de direção" },
      { emoji: "💫", text: "Sim, busco transformação" },
      { emoji: "🌟", text: "Sim, quero evoluir mais" }
    ]
  }
]

// Total steps in the quiz flow:
// 1. GenderSelection
// 2. NameInput
// 3. AgeSelection
// 4. PeopleCircle
// 5-15. Quiz Questions (11 questions)
// 16. SoulResult
// 17. MotivationResult
// 18. FinalCTA

export const TOTAL_STEPS = 18

export const getQuestionByStep = (step: number): QuizQuestion | undefined => {
  return questions.find(q => q.step === step)
}

export const isSpecialStep = (step: number): boolean => {
  return step === 16 || step === 17 || step === 18
}

export const getStepName = (step: number): string => {
  if (step === 1) return 'GenderSelection'
  if (step === 2) return 'NameInput'
  if (step === 3) return 'AgeSelection'
  if (step === 4) return 'PeopleCircle'
  if (step === 16) return 'SoulResult'
  if (step === 17) return 'MotivationResult'
  if (step === 18) return 'FinalCTA'
  return `Question${step - 4}`
}